export const colors = {
	lightGreen: '#4267B2',
	green: '#4267B2',
};

export const getProtocol = () => {
	if (window.location.protocol === 'https:') {
		return 'https://';
	} else {
		return 'http://';
	}
};

export const ENV = {
	dev: {
		loginUrl: '/user/login',
		businessCategoryUrl: '/business-category',
		devicetype: '/device-type',
		userSearch: '/user/search',
		calculator: '/advertisement/calculator',
		globalUrl: `${getProtocol()}${process.env.REACT_APP_BASE_URL}/api/v1/client`,
		client: '/client',
		priceplan: '/price-plan',
		propertyHolder: '/property-holder',
		role: '/role',
		businessCategory: '/business-category',
		device: '/device',
		status: '/status',
		devicelist: '/getDevices',
		createDevice: '/createDevice',
		deviceinstallation: '/device-installation',
		mainlocations: '/main-location',
		deviceslocation: '/device-location',
		location: '/location',
		deviceLocation: '/device-location',
		search: '/search',
		locationgroup: '/location/group',
		user: '/user',
		advertisement: '/advertisement',
		template: '/template',
		uploadassets: '/asset',
		locationsearch: '/advertisement/location/main/search',
		locationgroupsearch: '/advertisement/location/group/search',
		campaign: '/campaign',
		register: '/user/register',
		campaignLocationGroupSearch: 'location-group/search',
		// content library

		createFolder: '/content-library/create-ContentFolder',
		createFile: '/content-library/create-ContentFile',
		getClientContent: '/content-library/get-content',
		getClientFolders: '/content-library/get-content/folder',
		getClientFiles: '/content-library/getClientFiles',
		getClientByFolderId: '​/content-library/getClientByFolderId',
		renameFolder: '/content-library/renamefolder',
		renameFile: '/content-library/renamefile',

		// new content library urls
		contentLibrary: '/content-library',
		contentLibraryFolders: `/content-library/folders`,
		contentLibraryFiles: `/content-library/files`,

		// screenshot
		screenshot: '/screenshot',
		// refund
		refund: '/refund',
		feedback: '/feedback',

		company: '/company',

		//dashboard
		dashboard: '/dashboard',
		reports: '/reports',
		exception: '/exception-log',
	},
};
export const constants = {
	SAVE: 'Save',
	CANCEL: 'Cancel',
	YES: 'Yes',
	NO: 'No',
};
